export function propertyImagesBuilderUI(propertyImages) {
  return (
    propertyImages &&
    propertyImages.length &&
    propertyImages.map(propertyImage => {
      return {
        ...propertyImage
      };
    })
  );
}

export function propertyAssetTypesBuilderUI(assetTypes) {
  return assetTypes.map(assetType => {
    return {
      ...assetType
    };
  });
}

export function propertySummaryBuilderUI(property) {
  return {
    ...property
  };
}

export function propertyFinancialOverviewBuilderUI(property) {
  return {
    ...property
  };
}

export function propertyFinancialIncomeBuilderUI(property) {
  return {
    ...property
  };
}

export function propertyFinancialExpenseBuilderUI(property) {
  return property.map(item => {
    return {
      ...item
    };
  });
}

export function propertyFinancialCapitalDetailsBuilderUI(property) {
  return property.map(item => {
    return {
      ...item
    };
  });
}

export function propertyFinancialCapitalGrowthBuilderUI(property) {
  return property.map(item => {
    return {
      ...item
    };
  });
}

export function propertyLocationBuilderUI(property) {
  return {
    ...property
  };
}

export function floorPlanLayoutBuilderUI(layout) {
  return {
    ...layout
  };
}

export function timelineBuilderUI(timelines) {
  return timelines.map(timeline => {
    return {
      ...timeline
    };
  });
}

export function videoBuilderUI(data) {
  return {
    ...data
  };
}

export function propertyFinancialSummaryBuilderUI(data) {
  return {
    ...data
  };
}
